/**
 * Loại đơn vị
 */
export default {
    Summary: 1,
    Estimate: 2,
}